<script lang="ts">
  export let svgStyles: string = ''
</script>

<svg
  width="26"
  height="26"
  viewBox="0 0 26 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class="{svgStyles} absolute hidden lg-desktop:block"
>
  <path d="M0.113967 13.0222L12.6001 0.117346L25.6971 12.402L13.2204 25.7004L0.113967 13.0222Z" fill="black" />
</svg>
